export const getTransactionActivityUrl = (transactionReference: string): string => {
  const encoded = encodeURIComponent(transactionReference)
  return `/transactions?selected=${encoded}&q=${encoded}`
}
